import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import "firebase/compat/firestore"
import "firebase/compat/functions"
import "firebase/compat/storage"
import { firebaseConfig } from "../config"

let Firebase = null

// Only initialize Firebase on the client side
if (typeof window !== "undefined") {
  try {
    Firebase = !firebase.apps.length
      ? firebase.initializeApp(firebaseConfig)
      : firebase.app()

    if (process.env.JEST_WORKER_ID !== undefined) {
      // @ts-ignore
      Firebase.auth().useEmulator(`http://localhost:9099`, {
        disableWarnings: true,
      })
      Firebase.firestore().useEmulator(`localhost`, 8089)
    }
  } catch (error) {
    console.error("Firebase initialization error:", error)
    Firebase = null
  }
}

export default Firebase
